import { useQuery } from '@tanstack/react-query';

import { messagingApi } from './api/messaging.api';

export const messagingKeys = { threads: ['threads'] as const, messages: (id: string) => ['threads', id, 'messages'] as const };

export function useThreads() {
  return useQuery({ queryKey: messagingKeys.threads, queryFn: messagingApi.threads, refetchInterval: 15_000 });
}

export function useUnreadCount(): number {
  const { data } = useThreads();
  return data?.reduce((sum, t) => sum + t.unread, 0) ?? 0;
}

/** Polls every 10 s while a thread is open; no WebSocket in v1. */
export function useMessages(threadId: string | null) {
  return useQuery({ queryKey: messagingKeys.messages(threadId ?? ''), queryFn: () => messagingApi.messages(threadId as string), enabled: !!threadId, refetchInterval: 10_000 });
}
